"use client";

// [RUDDERSTACK-OLD disabled 2026-07-20] widget_viewed → central widget_impression; see webapp/docs/analytics
import { ctaClick } from "@/customAnalytics/trackingEvents";
import { cn } from "@/lib/utils";
import { AtSign, Phone } from "lucide-react";
import { useMemo, useRef, useState } from "react";

function buildTelHref(raw: string): string | null {
  const s = raw.trim().replace(/\s+/g, "");
  if (!s) return null;
  const cleaned = s.replace(/[^\d+]/g, "");
  if (!cleaned) return null;
  return cleaned.startsWith("+") ? `tel:${cleaned}` : `tel:${cleaned}`;
}

export default function CounselorCallCta1({ data }: { data: any }) {
  const ref = useRef<HTMLElement>(null);
  const sectionData = (data as any)?.data ?? data;
  const [visitorPhone, setVisitorPhone] = useState("");

  // [RUDDERSTACK-OLD disabled 2026-07-20] impression now central; see webapp/docs/analytics
  // useEffect(() => {
  //   if (ref.current) {
  //     FireWidgetViewedEvent(ref, "counselor_call_cta_section");
  //   }
  // }, []);

  const {
    title = "",
    title_text_color = "#000000",
    section_background_color = "#F4F4F4",
    phone_placeholder = "Enter your phone number",
    pill_background_color = "#FFFFFF",
    pill_border_color = "#E5E5E5",
    button_label = "Call Counsellor",
    button_background_color = "#BE2330",
    button_text_color = "#FFFFFF",
    counselor_tel = "",
    subtitle = "",
    subtitle_text_color = "#000000",
  } = sectionData || {};

  const telHref = useMemo(() => buildTelHref(String(counselor_tel ?? "")), [counselor_tel]);

  const isActive =
    sectionData?.status === true ||
    sectionData?.status === 1 ||
    sectionData?.status === "1";

  if (!sectionData || !isActive) {
    return null;
  }

  const handleCallClick = () => {
    ctaClick({
      section: "counselor_call_cta_section",
      component: "call_counselor",
      label: button_label,
      step: "call",
      entity: "tel_cta",
    });
  };

  return (
    <section
      ref={ref}
      className={cn(
        "flex w-full justify-center px-5 py-10 sm:px-9 sm:py-12 md:py-14"
      )}
      style={{ backgroundColor: section_background_color }}
    >
      <div className="flex w-full max-w-[720px] flex-col items-center gap-6 text-center">
        {title ? (
          <h2
            className={cn(
              "text-pretty px-2 text-xl font-bold leading-snug sm:text-2xl md:text-[28px]"
            )}
            style={{ color: title_text_color }}
          >
            {title}
          </h2>
        ) : null}

        <div
          className={cn(
            "flex w-full max-w-[640px] flex-col gap-3 rounded-full border p-1.5 shadow-sm sm:flex-row sm:items-center sm:gap-0 sm:pl-5 sm:pr-1.5 sm:py-1.5"
          )}
          style={{
            backgroundColor: pill_background_color,
            borderColor: pill_border_color,
          }}
        >
          <div className="flex min-h-[52px] flex-1 items-center gap-3 px-3 sm:px-0 sm:pr-3">
            <AtSign
              className="size-5 shrink-0 text-neutral-900 sm:size-[22px]"
              aria-hidden
            />
            <input
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              placeholder={phone_placeholder}
              value={visitorPhone}
              onChange={(e) => setVisitorPhone(e.target.value)}
              className="min-w-0 flex-1 bg-transparent text-left text-base text-neutral-900 outline-none placeholder:text-neutral-500"
              aria-label={phone_placeholder}
            />
          </div>

          {telHref ? (
            <a
              href={telHref}
              onClick={handleCallClick}
              className={cn(
                "inline-flex min-h-[52px] shrink-0 items-center justify-center gap-2 rounded-full px-6 py-3 text-base font-semibold transition-opacity hover:opacity-95 active:opacity-90 sm:min-h-[48px] sm:px-7"
              )}
              style={{
                backgroundColor: button_background_color,
                color: button_text_color,
              }}
            >
              <Phone className="size-5 shrink-0 sm:size-[22px]" aria-hidden strokeWidth={2.25} />
              {button_label}
            </a>
          ) : (
            <button
              type="button"
              disabled
              title="Configure counselor phone in CMS"
              className={cn(
                "inline-flex min-h-[52px] shrink-0 cursor-not-allowed items-center justify-center gap-2 rounded-full px-6 py-3 text-base font-semibold opacity-50 sm:min-h-[48px] sm:px-7"
              )}
              style={{
                backgroundColor: button_background_color,
                color: button_text_color,
              }}
            >
              <Phone className="size-5 shrink-0 sm:size-[22px]" aria-hidden strokeWidth={2.25} />
              {button_label}
            </button>
          )}
        </div>

        {subtitle ? (
          <p
            className="text-pretty px-2 text-sm font-normal sm:text-base"
            style={{ color: subtitle_text_color }}
          >
            {subtitle}
          </p>
        ) : null}
      </div>
    </section>
  );
}
